/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MatTabBase as ɵe,_MatTabMixinBase as ɵf} from './tab';
export {MatTabHeaderBase as ɵa,_MatTabHeaderMixinBase as ɵb} from './tab-header';
export {MatTabLabelWrapperBase as ɵc,_MatTabLabelWrapperMixinBase as ɵd} from './tab-label-wrapper';
export {MatTabLinkBase as ɵi,MatTabNavBase as ɵg,_MatTabLinkMixinBase as ɵj,_MatTabNavMixinBase as ɵh} from './tab-nav-bar/tab-nav-bar';